// extracted by mini-css-extract-plugin
export default {"paginationDiv":"MyPagination_paginationDiv__3OYBf"};